import { render, staticRenderFns } from "./VlAddFilesButton.vue?vue&type=template&id=3e20b42b&scoped=true&"
import script from "./VlAddFilesButton.vue?vue&type=script&lang=js&"
export * from "./VlAddFilesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20b42b",
  null
  
)

export default component.exports